import Body from '@oberoninternal/travelbase-ds/components/primitive/Body';
import { Box } from '@rebass/grid';
import { FormattedDate, FormattedMessage, useIntl } from 'react-intl';
import styled from 'styled-components';
import { TimeOpenClosed } from '../generated/graphql';
import { alwaysOpenMessage } from '../utils/getRelevantTime';

interface Props {
    weekdate: Date;
    times: TimeOpenClosed[];
}

const OperatingHoursRow = ({ weekdate, times }: Props) => {
    const intl = useIntl();
    return (
        <Container>
            <Box>
                <Body style={{ textTransform: 'capitalize', fontWeight: 600 }}>
                    <FormattedDate value={weekdate} format="WEEKDAY" />:
                </Body>
            </Box>
            <Box>
                {!times.length && (
                    <Body>
                        <FormattedMessage defaultMessage="gesloten" />
                    </Body>
                )}
                {times.map(({ timeOpen, timeClosed }, i) => (
                    <Body key={i}>
                        {timeOpen === '00:00' && timeClosed === '23:59' ? (
                            intl.formatMessage(alwaysOpenMessage)
                        ) : (
                            <>
                                {timeOpen} - {timeClosed} <FormattedMessage defaultMessage="uur" />
                            </>
                        )}
                    </Body>
                ))}
            </Box>
        </Container>
    );
};

export default OperatingHoursRow;

const Container = styled.div`
    display: flex;
    justify-content: space-between;

    @media screen and (min-width: ${({ theme }) => theme.mediaQueries.s}) {
        max-width: 34rem;
        justify-content: unset;
        > div {
            flex: 1;
        }
    }
`;
